export const staffQueryKeys = {
  all: ["staff"],

  list: () => [...staffQueryKeys.all, "list"],
  profiles: () => [...staffQueryKeys.all, "profiles"],
  detail: (id) => [...staffQueryKeys.all, "detail", id],
  byPersonnelIds: (ids) => [...staffQueryKeys.all, "by-personnel-ids", ids],
  managedStaff: (level) => [...staffQueryKeys.all, "managed-staff", level],
};
